import { staticLib } from "@public/js/static-lib.js";
import { defineComponent } from "@vue/runtime-core";
import format from "date-fns/format";

const tl = staticLib.gsap.timeline();

export const NotificationDetailsComponent = defineComponent({
    props: {
        notificationDetails: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
            required: true,
        },
    },
    setup(_props) {
        return {
            activateAnimation: undefined as undefined | gsap.core.Timeline,
        };
    },
    mounted() {
        tl.set([this.$refs.date, this.$refs.title, this.$refs.content], {
            y: 30,
            opacity: 0,
        });
    },
    computed: {
        formattedCreatedDate(): string {
            const createdAt = new Date(Date.parse(this.notificationDetails.created_at));
            return format(createdAt, "PP");
        },
    },
    watch: {
        active(newValue: boolean, _oldValue: boolean) {
            if (newValue) {
                setTimeout(() => {
                    this.activateAnimation = tl.to(
                        [this.$refs.date, this.$refs.title, this.$refs.content],
                        {
                            duration: 0.8,
                            y: 0,
                            opacity: 1,
                            delay: 0.1,
                            stagger: 0.05,
                            ease: "expo.out",
                        },
                    );
                }, 0);
            } else {
                // eslint-disable-next-line
                this.activateAnimation?.clear();
                tl.set([this.$refs.date, this.$refs.title, this.$refs.content], {
                    y: 30,
                    opacity: 0,
                    duration: 0,
                });
            }
        },
    },
});
